import { AxiosInstance } from 'axios';
import { ServiceBaseConfig } from './Interfaces/IAccountService';

export interface ISICCode {
  id: number;
  slug: string;
  description: string;
  sic_section_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: null | string;
}

export interface ISICCodeSection {
  id: number;
  slug: string;
  section: string;
  description: string;
  created_at: string;
  updated_at: string;
  deleted_at: null | string;
  sicCodes: ISICCode[];
}

type ListSicCodeSectionsResponse = {
  data: ISICCodeSection[];
};

export class SICCodeService {
  public static async listSicCodeSections(api: AxiosInstance, config: ServiceBaseConfig): Promise<ListSicCodeSectionsResponse> {
    const { data } = await api.get('sic-sections', config);

    return data;
  }
}
